import Book from "./book";
import EpubCFI from "./epubcfi";
import Contents from "./contents";
import Layout from "./layout";
import ePub from "./epub";

export default ePub;
export {
	Book,
	EpubCFI,
	Contents,
	Layout
};
